"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiffComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const diff_match_patch_1 = require("diff-match-patch");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const PILCROW_SIGN = "\u00b6";
const dmp = new diff_match_patch_1.diff_match_patch();
const DiffComponent = (props) => {
    const diff = (0, react_1.useMemo)(() => {
        const diffMain = dmp.diff_main(props.oldValue, props.newValue);
        // console.log("diffMain", _.cloneDeep(diffMain));
        dmp.diff_cleanupSemantic(diffMain);
        // console.log("diffMain after diff_cleanupSemantic", _.cloneDeep(diffMain));
        return diffMain;
    }, [props.oldValue, props.newValue]);
    if (!!process.env.IS_TEST_SERVER) {
        console.log("diff", diff);
    }
    const nodes = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        return mapGroupsToNodes(diff);
    }, [diff], lodash_1.default.isEqual);
    return React.createElement(React.Fragment, null,
        React.createElement("span", { style: { ...props.style } }, nodes));
};
exports.DiffComponent = DiffComponent;
const mapGroupsToNodes = (diff) => {
    return diff.map((group, idx) => {
        const key = group[0];
        let value = group[1] || "";
        // console.log(`group[${idx}]`, {key, value}, "test", /\S/.test(value));
        // if ((key === DIFF_DELETE || key === DIFF_INSERT) && !/\S/.test(value)) {
        //     const linebreaks = value.match(/(\S)*(\r\n|\r|\n)/g);
        //     if (linebreaks) {
        //         if (key === DIFF_DELETE) value = `\u00b6`.repeat(linebreaks.length);
        //         if (key === DIFF_INSERT) value = `\u00b6\n`.repeat(linebreaks.length);
        //     }
        // }
        if ((key === diff_match_patch_1.DIFF_DELETE || key === diff_match_patch_1.DIFF_INSERT)) {
            // const hasSignificantCharacters = /\S/.test(value)
            const linebreaks = value.match(/(\S)*(\r\n|\r|\n)/g);
            if (linebreaks) {
                if (key === diff_match_patch_1.DIFF_DELETE)
                    value = value.replace(/(\r\n|\r|\n)/g, `${PILCROW_SIGN}\n`);
                if (key === diff_match_patch_1.DIFF_INSERT)
                    value = value.replace(/(\r\n|\r|\n)/g, `${PILCROW_SIGN}\n`);
            }
        }
        let nodeStyles;
        if (key === diff_match_patch_1.DIFF_INSERT)
            nodeStyles = { color: "green", backgroundColor: "#b5efdb" };
        if (key === diff_match_patch_1.DIFF_DELETE)
            nodeStyles = { color: "red", backgroundColor: "#fec4c0", textDecoration: "line-through" };
        return React.createElement("span", { style: nodeStyles, key: idx }, value);
    });
};
